import { PLAYER_ROLES } from '@la/types';
export const isPlayer = (registrant) => {
    return (typeof registrant.role !== 'undefined' &&
        PLAYER_ROLES.includes(registrant.role));
};
export const isStaff = (registrant) => {
    return typeof registrant.roles !== 'undefined';
};
